import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { appConfig } from 'cd-eft/config/AppConfig';

const designStore = stores.AppStore.designStore;

export class ProjectPanelVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  @observable error = false;
  @observable errorMsg = '';
  @observable surfaceDefTitle: string = 'Surface 1';
  @observable surfaceDefClassId: number = appConfig.tempHardCodes.surfaceDefClass.surfaceDefClassId;
  // @observable projectTitle: string = designStore.projectsStore.currentProject.projectTitle;

  initialformValidation = {
    formErrors: {
      projectTitle: '',
      surfaceDefTitle: '',
      surfaceDefClassId: '',
    },
  };

  @observable formValidation = { ...this.initialformValidation };

  // Init API classes

  //Needed in case of invisible project
  @action.bound setProjectTitle(event: any) {
    designStore.projectsStore.currentProject.projectTitle = event.target.value;
    if (event.target.value !== '') {
      this.formValidation.formErrors.projectTitle = '';
    } else {
      this.formValidation.formErrors.projectTitle = 'You must enter a project name';
    }
  }

  @action.bound setSurfaceDefTitle(event: any) {
    if (event.target.value !== '') {
      this.formValidation.formErrors.surfaceDefTitle = '';
      this.surfaceDefTitle = event.target.value;
    } else {
      this.formValidation.formErrors.surfaceDefTitle = 'You must enter the name of surface';
      this.surfaceDefTitle = event.target.value;
    }
  }

  @action.bound setSurfaceDefClassId(event: any) {
    if (event.target.value !== '') {
      this.formValidation.formErrors.surfaceDefClassId = '';
      this.surfaceDefClassId = event.target.value;
    }
  }
  /*
  validateSurfaceProjectDetails() {
    if (!this.surfaceDefTitle) {
      this.formValidation.formErrors.surfaceDefTitle = 'You must enter the name of surface';
      return false;
    }
    if (!designStore.projectsStore.currentProject.projectTitle) {
      this.formValidation.formErrors.projectTitle = 'You must enter a project name';
      return false;
    }
    if (!this.surfaceDefClassId || this.surfaceDefClassId != 1) {
      this.formValidation.formErrors.surfaceDefClassId = 'You must select a surface type as Survey';
      return false;
    }
    return true;
  }
 
  @action.bound async submitNewSurface(callback) {
    if (!this.validateSurfaceProjectDetails()) return;
    const postJSON: ICreateSurfaceDefPOST = {
      sessionUuid: designStore.projectsStore.currentProject.sessionList[0].sessionUuid,
      sessionResourceId: appConfig.tempHardCodes.sessionResource.sessionResourceId,
      surfaceDefTypeId: appConfig.tempHardCodes.surfaceDefType.surfaceDefTypeId,
      surfaceDefClassId: this.surfaceDefClassId,
      surfaceDefTitle: this.surfaceDefTitle,
      srid: appConfig.tempHardCodes.wkid,
      zUnits: appConfig.tempHardCodes.zUnits,
      xMin: appConfig.tempHardCodes.xMin,
      xMax: appConfig.tempHardCodes.xMax,
      yMin: appConfig.tempHardCodes.yMin,
      yMax: appConfig.tempHardCodes.yMax,
      shape: appConfig.tempHardCodes.shape,
      surfaceJson: appConfig.tempHardCodes.surfaceJson,
    };
    console.log('createSurfaceDef Payload = ', postJSON);

    try {
      if (designStore.projectsStore.currentProject.projectTitle.includes('Untitled Project')) {
        const currentProject = designStore.projectsStore.currentProject;
        // currentProject.projectTitle = this.projectTitle;
        await updateProject(currentProject);
      }
      const response: ICreateSurfaceDefResponse = await this.createSurfaceDefAPI.postCreateSurfaceDef(postJSON);
      console.log('createSurfaceDesignProject Response = ', response);
      const data = response['data'];
      if (data) {
        designStore.currentSurface.surfaceDefId = data.surfaceDefId;
        designStore.currentSurface.surfaceDefTitle = data.surfaceDefTitle;
        designStore.currentSurface.surfaceDefClassId = this.surfaceDefClassId;
      }

      designStore.hasSurface = true;

      callback();
    } catch (error) {
      designStore.resetSurface();
      designStore.hasSurface = false;
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  }
  @action.bound handleCancel = () => {
    designStore.resetSurface();
    // setStore.currentSurface = {}; // Do we need to reset surface in Design Store?
  };

  @action.bound async displayProjectMetadata() {
    console.log('Get Surface metadata by surfaceDefId= ', designStore.currentSurface.surfaceDefId);
    try {
      const response: IGetSurfaceDefByIdResponse = await this.getSurfaceDefByIdAPI.getSurfaceDefById(
        designStore.currentSurface.surfaceDefId
      );

      const data = response['data'];
      if (data) {
        designStore.currentSurface.surfaceDefId = data.surfaceDefId;
        designStore.currentSurface.surfaceDefTitle = data.surfaceDefTitle;
        designStore.currentSurface.surfaceDefClassId = data.surfaceDefClassId;
        designStore.currentSurface.surfaceDefClassName = data.surfaceDefClassName;
      }
      designStore.hasSurface = true;
    } catch (error) {
      designStore.hasSurface = false;
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  } */
}
